import { PudoLocation } from '@pperform/pp-data-mappers';
import { Stack } from 'components/Stack';
import { useDetectDevice, useLocationConsent } from 'hooks';
import clockIconSVG from 'icons/clock.svg';
import phoneIconSVG from 'icons/telephone.svg';
import { useState } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import { MapView } from '../../../../../../MapView';
import { DropOffDetailModal } from '../DropOffDetailModal';
import { getOpenStatus } from './DropOffLicationDetails.service';
import {
  DropOffLocationAddress,
  DropOffLocationTitle,
  MapViewContainer,
  OpenNowAndClosed,
  ViewMoreCTA,
} from './DropOffLocation.styles';

const ICON_SIZE = 24;

interface DropOffLocationDetailsProps {
  data: PudoLocation;
}

export const DropOffLocationDetails = ({
  data,
}: DropOffLocationDetailsProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useDetectDevice();
  const [showDropOffModal, setShowDropOffModal] = useState<boolean>(false);

  const center = { lat: data.lat, lng: data.lng };
  const openStatus = getOpenStatus(data.operatingHoursCalc);

  const showDropOffDetails = () => {
    setShowDropOffModal(true);
  };

  const { line1, line2, postalCode, city } = data.address;
  const address = [line1, line2, postalCode, city].filter(Boolean).join(', ');

  const { isAllowGoogleMaps } = useLocationConsent();

  return (
    <>
      <Stack
        direction={`${isDesktop ? 'row' : 'column'}`}
        gap={16}
        isFullWidth
        justify="flex-start"
        align="flex-start"
      >
        {isAllowGoogleMaps && (
          <MapViewContainer>
            <MapView
              center={center}
              isDropOffEmpty={!data.address}
              isViewOnlyMode
            />
          </MapViewContainer>
        )}

        <Stack gap={8} direction="column">
          <DropOffLocationTitle>
            {data.address.locationType}
          </DropOffLocationTitle>
          <DropOffLocationAddress>
            <div>{address}</div>

            {openStatus && (
              <Stack direction="row" gap={8} align="center">
                <ReactSVG
                  src={clockIconSVG}
                  width={ICON_SIZE}
                  height={ICON_SIZE}
                  aria-hidden
                />
                <OpenNowAndClosed>{t(openStatus)}</OpenNowAndClosed>
              </Stack>
            )}

            {data.address.phone && (
              <Stack direction="row" gap={8}>
                <ReactSVG
                  src={phoneIconSVG}
                  width={ICON_SIZE}
                  height={ICON_SIZE}
                  aria-hidden
                />
                <div>{data.address.phone}</div>
              </Stack>
            )}

            <ViewMoreCTA onClick={showDropOffDetails}>
              {t('VIEW_MORE')}
            </ViewMoreCTA>
          </DropOffLocationAddress>
        </Stack>
      </Stack>
      <DropOffDetailModal
        dropOff={data}
        isOpen={showDropOffModal}
        onClose={() => setShowDropOffModal(false)}
      />
    </>
  );
};
